import { asyncPostList } from "../fetch";

// submitting contact
export const postContact = async (inputValues) => {
  try {
    return await asyncPostList({
      collection_name: "ecomcontactus",
      data: inputValues,
    });
  } catch (error) {
    console.log("Error postContact", error);
    return error;
  }
};
